/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { Chip, ChipProps } from '@mui/material';

import { useHUChipStyles } from './HUChip.styles';

type HUChipProps = Omit<ChipProps, 'color'> & { color: string };

export function HUChip(props: HUChipProps) {
  const { color, classes = {}, variant, ...otherProps } = props;
  const chipClasses = useHUChipStyles({
    color,
    isOutlined: variant === 'outlined',
  });

  return (
    <Chip
      {...otherProps}
      variant={variant}
      classes={{
        ...classes,
        root: chipClasses.root,
        outlined: chipClasses.outlined,
        label: chipClasses.label,
      }}
    />
  );
}
